import { DropdownMenu, type DropdownTriggerProps, Button } from "@mdotm/shadcn/mdotm/components";
import type { FunctionComponent, JSX } from "react";
import type { InvestmentPickerDialogProvider } from "./InvestmentPickerDialog";
import { getCompositionPickerConfigOptions } from "./investmentPickerConfig";
import type { PortfolioLabInvestmentType } from "../../ctx";

type InvestmentPickerParams = { type: PortfolioLabInvestmentType; items: InvestmentPickerDialogProvider[] };
export type InvestmentPickerButtonProps = {
	onSubmitAsync(params: InvestmentPickerParams): Promise<void>;
	/**
	 * The dropdown trigger. Defaults to the filled "Add Portfolio" button used in the page header; the
	 * composition toolbar passes a ghost/outline x-small variant. Must be a stable (module-level) component.
	 */
	Trigger?: FunctionComponent<DropdownTriggerProps>;
};

function LoadCompositionTrigger({ state, ...props }: DropdownTriggerProps): JSX.Element {
	return (
		<Button palette="primary" size="small" data-qualifier="PortfolioLab/LoadComposition/Button" {...props}>
			Add Portfolio
		</Button>
	);
}

const compositionPickerConfigOptions = getCompositionPickerConfigOptions();
export function InvestmentPickerButton({
	onSubmitAsync,
	Trigger = LoadCompositionTrigger,
}: InvestmentPickerButtonProps): JSX.Element {
	return (
		<DropdownMenu
			Trigger={Trigger}
			actions={compositionPickerConfigOptions.map((config) => ({
				icon: config.icon,
				label: config.label,
				"data-qualifier": `PortfolioLab/LoadComposition/Option(${config.type})`,
				onClick: () =>
					config.spawn({ onSubmitAsync: (entities) => onSubmitAsync({ type: config.type, items: entities }) }),
			}))}
		/>
	);
}
